import EventTimestamp from './EventTimestamp';

export default EventTimestamp;
